export const JOB_HISTORY_QUERY_KEY = 'JOB_HISTORY_QUERY_KEY';
export const GENERATOR_LIST_QUERY_KEY = 'GENERATOR_LIST_QUERY_KEY';
export const FLAGS_LIST_QUERY_KEY = 'FLAGS_LIST_QUERY_KEY';
